import Vue from 'vue'
import App from './App.vue'
import "@/assets/css/global.css"
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import "mapbox-gl/dist/mapbox-gl.css"


Vue.config.productionTip = false

Vue.use(ElementUI)

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
